module.exports = __webpack_public_path__ + "static/img/bca.77b3533.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bca.png
// module id = Nvqv
// module chunks = 1